import { EditorState } from 'prosemirror-state';

export const getTooltipAnchorEl = (domAtPos: Node) =>
  domAtPos.nodeName === 'SPAN'
    ? domAtPos.parentElement?.parentElement
    : domAtPos.nodeName === 'P'
    ? domAtPos.parentElement
    : domAtPos;

export const isImageSelection = (state: EditorState) => {
  return (
    // @ts-ignore
    state.selection?.node?.type === state.schema.nodes.image && state.selection?.node.attrs.src
  );
};

export const isFlashCardSelection = (state: EditorState) => {
  return (
    // @ts-ignore
    state.selection?.node?.type === state.schema.nodes.flash_card
  );
};

export const isDividerSelection = (state: EditorState) => {
  return (
    //@ts-ignore
    state.selection?.node?.type === state.schema.nodes.horizontal_rule
  );
};
